import { forwardRef } from '@hover/blueprint';
import React from 'react';

import { formatProductDescriptions } from 'src/modules/homeownerApp/components/Products/ProductDescriptions';
import type { ProductSwatchProps } from 'src/modules/homeownerApp/components/materialCallouts/ProductSwatch';
import { ProductSwatch } from 'src/modules/homeownerApp/components/materialCallouts/ProductSwatch';
import type { RegionWithDisabledRegions } from 'src/modules/homeownerApp/hooks/useVariationEdits';
import { toDesignerProduct } from 'src/modules/homeownerApp/productCatalogData';
import type { ProductCatalogVariationFragment } from 'src/shared/graphql/generated';

interface ProductVariationProductSwatchProps
  extends Omit<ProductSwatchProps, 'hexColor' | 'imageAltText' | 'imageUrl'> {
  productVariation: ProductCatalogVariationFragment;
  region: RegionWithDisabledRegions | undefined;
}

/**
 * ProductVariationProductSwatch is a wrapper for ProductSwatch using the
 * ProductVariation data source.
 */
export const ProductVariationProductSwatch = forwardRef<
  ProductVariationProductSwatchProps,
  'div'
>(({ productVariation, region, ...props }, ref) => {
  const hexColor = productVariation.genAiColor?.hex;
  const imageUrl = productVariation.image?.redirectUrl;

  const designerProduct = toDesignerProduct(productVariation);

  const imageAltText = designerProduct
    ? formatProductDescriptions(region, designerProduct).altText
    : productVariation.name;

  return (
    <ProductSwatch
      hexColor={hexColor}
      imageAltText={imageAltText}
      imageUrl={imageUrl}
      ref={ref}
      {...props}
    />
  );
});
